module.exports = __webpack_public_path__ + "img/74_56.b40bff6e.png";